import React from 'react';
import { Typography, Container } from '@mui/material';

const PrivacyPolicy = () => {
  React.useEffect(() => {
    document.title = 'My Store - Privacy Policy';
  }, []);

  return (
    <Container maxWidth="md">
      <Typography variant="h4" component="h1" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        This Privacy Policy describes how we collect, use, and protect your personal information.
      </Typography>
      {/* Add more content here */}
    </Container>
  );
};

export default PrivacyPolicy;